import { gql } from 'apollo-boost';

export const getUserPagesQuery = gql`
  query {
    UserPages {
      active {
        id
        fullname
        avatar {
          thumbnailUrl
        }
        pageName
        defaultTab
        visibleTabs
        language
        isDefault
      }
      deactive {
        id
        fullname
        avatar {
          url
        }
        pageName
        defaultTab
        visibleTabs
        language
        isDefault
      }
    }
  }
`;

export const newUserPageQuery = gql`
  mutation NewPage($pageName: String!, $language: PageLanguageType!) {
    NewPage(input: { pageName: $pageName, language: $language }) {
      fullname
      avatar {
        id
        url
        thumbnailUrl
      }
      pageName
      defaultTab
      visibleTabs
      isDefault
      language
    }
  }
`;

export const getUsersQuery = gql`
  query Users(
    $skip: Int!
    $take: Int!
    $sortKey: String
    $sortDirection: SortDirectionType
    $username: String
    $pageName: String
  ) {
    Users(
      input: {
        skip: $skip
        take: $take
        sortKey: $sortKey
        sortDirection: $sortDirection
        username: $username
        pageName: $pageName
      }
    ) {
      totalCount
      items {
        id
        fullname
        username
        pageName
        url
        tags
        createdDate
        accountType
        expireDate
        bio
      }
    }
  }
`;

export const newUserQuery = gql`
  mutation NewUser(
    $shortLink: String!
    $username: String!
    $password: String!
    $isPro: Boolean!
    $bio: String
    $fullname: String
    $tags: [String!]
  ) {
    NewUser(
      input: {
        shortLink: $shortLink
        username: $username
        password: $password
        fullname: $fullname
        tags: $tags
        bio: $bio
        isPro: $isPro
      }
    ) {
      id
      fullname
      username
      pageName
      url
      tags
      createdDate
      accountType
      expireDate
      bio
    }
  }
`;

export const editUserQuery = gql`
  mutation EditUser(
    $id: ID!
    $shortLink: String!
    $fullname: String
    $tags: [String!]
    $bio: String
  ) {
    EditUser(
      input: {
        id: $id
        shortLink: $shortLink
        fullname: $fullname
        tags: $tags
        bio: $bio
      }
    ) {
      id
      fullname
      username
      pageName
      url
      tags
      createdDate
      accountType
      expireDate
      bio
    }
  }
`;
